export default __webpack_public_path__ + "static/media/loading.15656c08.gif";